import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

const getDataFromNode = function(node) {
    return ['id', 'x', 'y', 'src', 'zIndex'].reduce((data, key) => {
        return {...data, [key]: node.attr[key]};
    }, {});
};

class SlideshowButtonNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node),
            height: 0,
            hovered: false,
        };
    }

    handleClick() {
        const {action} = this.props;
        if (action === 'next'){
            this.nextSlide();
        } else if (action === 'prev'){
            this.prevSlide();
        }
    }

    nextSlide() {
        document.dispatchEvent(new Event('next-slide'));
    }

    prevSlide() {
        document.dispatchEvent(new Event('prev-slide'));
    }

    onImgLoad({target:img}) {
        // The image is an sprite image (a single image containing 5 elements).
        this.setState({height: parseInt(img.naturalHeight) / 5});
    }

    styleBackgroundPosition() {
        const {height} = this.state;
        const {disableButton} = this.props;

        //if there are no more slides, we select the last image
        if (disableButton) {
            return `0 -${parseInt(height) * 4}px`;
        } else if (this.state.hovered) {
            return `0 -${parseInt(height) * 2}px`;
        } else {
            return '0 0';
        }
    }

    onButtonMouseOver() {
        this.setState({ hovered:true });
    }

    onButtonMouseOut() {
        this.setState({ hovered:false });
    }

    render() {
        const {moduleURL = '', disableButton} = this.props;
        const {x = 0, y = 0, src = '', height = 0, zIndex = null} = this.state;
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            display: 'block',
            height: `${height}px`,
            background: `url(${moduleURL}/media/${src}) no-repeat`,
            backgroundPosition: this.styleBackgroundPosition(),
        };

        if (zIndex !== null) {
            divStyle['zIndex'] = zIndex;
        }


        return (
            <button className="node button-node slideshow-button-node" onClick={this.handleClick.bind(this)} style={divStyle} onMouseOut={this.onButtonMouseOut.bind(this)}
                    onMouseOver={this.onButtonMouseOver.bind(this)}
                    disabled={disableButton}>
                {/* This non-visible image element is used to get the height of the image. */}
                <img className="visibility-hidden" onLoad={this.onImgLoad.bind(this)}
                     src={`${moduleURL}/media/${src}`} />
            </button>
        );
    }
}

SlideshowButtonNode.propTypes = {
    node: PropTypes.object.isRequired,
    action: PropTypes.string.isRequired, //prev or next
    disableButton: PropTypes.bool.isRequired,
    moduleURL: PropTypes.string.isRequired,
};

export default withRouter(SlideshowButtonNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/slideshow-button-node.js